import { useEffect, useState } from 'react'

import { useStore } from '~/store/store'

export function useCentralizedToasts({ isApiError, isDipsError }: { isApiError: boolean; isDipsError: boolean }) {
    const addToast = useStore(state => state.toaster.actions.addToast)
    const [hasShownDipsError, setHasShownDipsError] = useState(false)
    const [hasShownApiError, setHasShownApiError] = useState(false)

    useEffect(() => {
        function addCentralToast(message: string, dataTestSuffix?: string) {
            addToast({
                message,
                color: 'critical',
                persist: true,
                placement: 'top-center',
                size: 'medium',
                dataTestSuffix,
            })
        }

        if (isDipsError && !isApiError && !hasShownDipsError) {
            addCentralToast(
                'Noe data ble ikke hentet fra DIPS. Det kan hende ventelister, operasjonsbestilling og annen funksjonalitet ikke fungerer som forventet.',
                'dips-error'
            )
            setHasShownDipsError(true)
        }
        if (isApiError && !hasShownApiError) {
            addCentralToast('Noe data ble ikke hentet. Det kan hende Hero ikke fungerer som forventet.', 'api-error')
            setHasShownApiError(true)
        }
    }, [isDipsError, hasShownDipsError, hasShownApiError, isApiError, addToast])
}
